import {
  DYNAMIC_REWARDS_TAB_CONTENT_GET_SUCCESS,
  DYNAMIC_REWARDS_TAB_CONTENT_GET_FAILURE,
} from '../actions/types';
import dynamicRewardsTabConfig from '../configs';

/** @type {{config: object, placements: array.<object>}} */
const initialState = {
  config: dynamicRewardsTabConfig,
  namespaceDefaults: {
    isLoaded: false,
    isLoading: false,
    data: [],
  },
};

/**
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
const dynamicRewardsTabContent = (state = initialState, action) => {
  const { context = {} } = action;
  const { namespace = 'default' } = action.namespace ? action : context.options || {};
  const { namespaceDefaults } = state;
  const { [namespace]: namespaceState = namespaceDefaults } = state;

  switch (action.type) {
    case DYNAMIC_REWARDS_TAB_CONTENT_GET_SUCCESS: {
      const response = action.payload.response[0];

      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          data: response,
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    case DYNAMIC_REWARDS_TAB_CONTENT_GET_FAILURE: {
      return {
        ...state,
        [`namespace-${namespace}`]: {
          ...namespaceState,
          data: [],
          isLoading: false,
          isLoaded: true,
        },
      };
    }
    default: {
      const { options = {} } = action;
      // Handle setting isLoading to true for raw OCAPI action
      if (options.success === DYNAMIC_REWARDS_TAB_CONTENT_GET_SUCCESS) {
        return {
          ...state,
          [`namespace-${namespace}`]: {
            ...namespaceState,
            isLoading: true,
          },
        };
      }

      return state;
    }
  }
};

export default dynamicRewardsTabContent;
